import { render, staticRenderFns } from "./supplier-search-form.vue?vue&type=template&id=95d6a9a2"
import script from "./supplier-search-form.vue?vue&type=script&lang=ts"
export * from "./supplier-search-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports